// Sculpture catalogue.
// Images are served from /public/images/ — self-hosted so the site works on any network.
const creatureDescription =
    "The creature is a special being made of paperclips. When I made this creature, I felt curious. I wondered If I keep going. So I got to work, then after 5–8 hours of stabbing paperclips into an eraser, I made it. Also, along the way, people at school said how cool it was.";

const creatureLongDescription = `This creature is like a little sci-fi creature that has high intelligence and shows up in groups sometimes. They are the civilians, the ones who wish to better themselves but end up in the same place as before. It represents the stuff I had in mind at the time to show creativity. "We the people try so hard just to stagnate."`;

export const sculptures = [
    {
        id: "01",
        title: "Creature 1",
        year: "2026",
        material: "Pink eraser and paperclips",
        size: "10 in. long × 10 in. wide × 11 in. tall — base 10 × 10 in.",
        description: creatureDescription,
        longDescription: creatureLongDescription,
        images: [
            { url: "/images/c1-01-hero.jpeg", view: "Hero" },
            { url: "/images/c1-02-overhead.jpeg", view: "Overhead" },
            { url: "/images/c1-03-threequarter.jpeg", view: "Three-quarter" },
            { url: "/images/c1-04-context.jpeg", view: "In context" },
            { url: "/images/c1-05-lowangle.jpeg", view: "Low angle" },
            { url: "/images/c1-06-profile.jpeg", view: "Profile" },
        ],
    },
    {
        id: "02",
        title: "Creature 2",
        year: "2026",
        material: "Pink eraser and paperclips",
        size: "10 in. long × 9 in. wide × 22 in. tall — base 10 × 10 in.",
        description:
            "In my first design, when it was almost done, I thought about making it taller and less dense, but I saved that for this one because I wanted Creature 1 to be its own thing. I stopped at a certain point because it started leaning and sometimes falling over. I could make it taller since it's attached to the wood block, but I'm not going to.",
        longDescription: `Creature 2 is a higher-class man within the creature society. Creature 2 makes sure the other creatures don't die. They are probably the most important creature out of them all — without them, the creature species would go extinct. "Do we have to hold everything together, even when it's heavy?"`,
        images: [
            { url: "/images/c2-01-hero.jpeg", view: "Hero" },
            { url: "/images/c2-02-fullbody.jpeg", view: "Full body" },
            { url: "/images/c2-03-base.jpeg", view: "Base detail" },
            { url: "/images/c2-04-overhead.jpeg", view: "Overhead" },
            { url: "/images/c2-05-close.jpeg", view: "Close crop" },
        ],
    },
    {
        id: "03",
        title: "Creature 3",
        year: "2026",
        material: "Pink eraser and paperclips",
        size: "8 in. long × 9 in. wide × 10 in. tall — base 10 × 10 in. (working on getting base)",
        description:
            "I had the idea of putting paperclips around another one, because I thought it would create something unique — it turns out the paperclips are small and can only go so far. So I stopped here at this small stage. But there are future plans with Creature 4.",
        longDescription: `Creature 3 is special, unusual perhaps, because its only job is to entertain the king (Creature 4). It's not happy at all, and it's also the jester. They don't like being around the king. It's their unfortunate fate — without them, the king would go mad. There are no new kings because no one wants to be one — too much stress on the creatures. "Why do we suffer for others just to lift them up?"`,
        images: [
            { url: "/images/c3-01-hero.jpeg", view: "Hero" },
            { url: "/images/c3-02-threequarter.jpeg", view: "Three-quarter" },
            { url: "/images/c3-03-overhead.jpeg", view: "Overhead" },
            { url: "/images/c3-04-close.jpeg", view: "Close detail" },
            { url: "/images/c3-05-context.jpeg", view: "In context" },
        ],
    },
    {
        id: "04",
        title: "Creature 4",
        year: "2026",
        material: "Pink eraser and paperclips",
        size: "14 in. long × 14 in. wide × 14 in. tall — base 10 × 10 in.",
        description:
            "For Creature 4, I wanted the idea from Creature 3, but different. Instead of the paperclips going around each one once, I would do that 10–30 times, making a much bigger art piece than the last one. This also took much longer than the others because I can't just stab a paperclip into an eraser — I have to put a paperclip around a paperclip many times, then do it again. And the amount is a lot bigger.",
        longDescription: `The king is weird. It's not like any other role — it has all the power, yet none. It could be taken away for a greater leader, but no one dares to lead because who would lead such a tragic world where nothing maintains itself unless there is more of itself spilt into roles. Those roles are crucial — without the roles, the world will fall apart. The end is never the end.`,
        images: [
            { url: "/images/c4-06-eyelevel.jpeg", view: "Hero" },
            { url: "/images/c4-01-hero.jpeg", view: "Frontal" },
            { url: "/images/c4-02-frontal.jpeg", view: "Profile" },
            { url: "/images/c4-03-detail.jpeg", view: "Detail" },
            { url: "/images/c4-04-context.jpeg", view: "In context" },
            { url: "/images/c4-05-closecrop.jpeg", view: "Close crop" },
            { url: "/images/c4-07-topdown.jpeg", view: "Top down" },
        ],
    },
    {
        id: "05",
        title: "Creature 5",
        year: "2026",
        material: "White eraser and paperclips",
        size: "11 in. long × 9 in. wide × 10 in. tall — base pending",
        fit: "cover",
        description:
            "It took 11 hours because this had a very particular role, and I wanted a design that fits and meets this standard by attaching the neck to show the utmost amount of workloads that pile up after peer pressure — just a thought in mind.",
        longDescription: `It is the protester. It wonders curiously upon a broken system that is meant to build on its failures. To lead is to seek a new loop in which one holds leadership that can be replaced by new leaders, because leaders can only hold on for so long before they collapse. Do they make bad decisions? To make us rebel is their intention, or not? Because broken systems lack freedom and people want freedom, but even if that happens, a new leader will have the same flaws. "Your leadership smells like freedom, but it is just another lie."`,
        images: [
            { url: "/images/c5-02-overhead.webp", view: "Overhead" },
            { url: "/images/c5-01-hero.webp", view: "In context" },
            { url: "/images/c5-03-threequarter.webp", view: "Three-quarter" },
            { url: "/images/c5-04-close.webp", view: "Close detail" },
            { url: "/images/c5-05-lowangle.webp", view: "Low angle" },
            { url: "/images/c5-06-topdown.webp", view: "Top down" },
        ],
    },
];

export const heroPortrait = "/images/portrait.jpeg";
